import axios from 'axios';
import { API_URL } from '@/config';

export default {

  create(data) {
    return axios.post(`${API_URL}/mailing-broadcast`, data);
  },

  list() {
    return axios.get(`${API_URL}/mailing-broadcast`);
  },

};
